import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { IntegratedDataSetRecordLogEntryFilterParameterDialog } from "../Ui/Dialogs/IntegratedDataSetRecordLogEntryFilterParameterDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandIntegratedDataSetRecordLogEntryFilterPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandIntegratedDataSetRecordLogEntryFilterProperties = {
    [name in keyof EntityCommandIntegratedDataSetRecordLogEntryFilterPropertyValues]: Property<EntityCommandIntegratedDataSetRecordLogEntryFilterPropertyValues[name]>
};

export interface IEntityCommandIntegratedDataSetRecordLogEntryFilter extends IEntityCommand, EntityCommandIntegratedDataSetRecordLogEntryFilterProperties
{
}

export class EntityCommandIntegratedDataSetRecordLogEntryFilter extends EntityCommand implements IEntityCommandIntegratedDataSetRecordLogEntryFilter
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandIntegratedDataSetRecordLogEntryFilter";
    public static override className = "EntityCommandIntegratedDataSetRecordLogEntryFilter";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandIntegratedDataSetRecordLogEntryFilterPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Filter",
                entityName: "IntegratedDataSetRecordLogEntry",
                key: "FILTER",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandIntegratedDataSetRecordLogEntryFilterPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        caller = entityCommandInformation.caller.get();

                    if (!caller)
                        return;

                    if (!caller.integratedDataSetRecordLogEntryFilterParameterDialog)
                        caller.integratedDataSetRecordLogEntryFilterParameterDialog = new IntegratedDataSetRecordLogEntryFilterParameterDialog();

                    return (
                        (caller.integratedDataSetRecordLogEntryFilterParameterDialog as IntegratedDataSetRecordLogEntryFilterParameterDialog)
                            .openAsync()
                            .then(data =>
                            {
                                if (data.dialogResult !== DialogResultEnum.ok)
                                    return;

                                return data.promiseData;
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

